import { LocationData } from "@/location/location";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { get } from "@/api/api";

export const electricityPriceQuantityUnits = {
  "cent / kilowatt_hour": "¢/kWH"
}

export type ElectricityPrice = {
  state: string;
  price: Quantity;
}

export type Quantity = {
  magnitude: number;
  units: keyof typeof electricityPriceQuantityUnits
}

export const useElectricityPrice = (location: LocationData) => {
  return useSuspenseQuery({
    queryKey: ["electricity-price", location.state],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => await get<ElectricityPrice>(`electricity-price/${location.state}/`)
  })
}

export const useHasElectricityPrice = (location: LocationData) => {
  const { data, isError } = useQuery({
    queryKey: ["electricity-price", location.state],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => await get<ElectricityPrice>(`electricity-price/${location.state}/`),
    retry: false,
  });
  return !isError && data !== undefined;
}

export const ElectricityPriceTooltipMessage = ({ location }: { location: LocationData }) => {
  const { data: electricityPrice } = useElectricityPrice(location);

  return (
    <span>
      Using a rate of
      {' '}
      <span className="font-bold text-thalo-blue">
        {electricityPrice.price.magnitude} {electricityPriceQuantityUnits[electricityPrice.price.units]}
      </span>
      {' '}
      at this location
    </span>
  )
}
